// No upload/network work begins before this callback. Cancellation is final,
// including after a throttled background timer or component cleanup.
export function startSendCountdown(seconds: number, onTick: (seconds: number) => void, onElapsed: () => void) {
  const deadline = performance.now() + seconds * 1000;
  let active = true;
  onTick(seconds);
  const timer = window.setInterval(() => {
    if (!active) return;
    const remaining = Math.max(0, Math.ceil((deadline - performance.now()) / 1000));
    if (remaining > 0) onTick(remaining);
    else {
      active = false;
      window.clearInterval(timer);
      onElapsed();
    }
  }, 100);
  return () => { active = false; window.clearInterval(timer); };
}
